<template>
  <PublicPopup ref="PopupRef" @close="handleEmitClose" @manual-close="handleEmitManualClose">
    <template #content>
      <div class="download-popup">
        <div class="header">
          <div class="header__images">
            <van-image src="/theme/skin_theme/logo.png " />
          </div>
          <div class="header__label">
            <p>{{ GameNameStr }}</p>
          </div>
        </div>

        <InstallButtons
          ref="InstallButtonsRef"
          @quick="handleQuick"
          @install="handleInstall"
          @tutorial="handleTutorial"
        />
      </div>
    </template>
  </PublicPopup>

  <DownloadGuidePopup2 ref="DownloadGuidePopupRef" />
</template>

<script setup>
// 读取缓存中的GRUPO
const GameNameStr = computed(() => {
  return JSON.parse(localStorage.getItem('localConfig')).gameNameStr || ''
})

const PopupRef = ref(null)
const InstallButtonsRef = ref(null)

const installPrompt = ref(null)

// 下载pwa的前置弹窗
const open = () => {
  installPrompt.value = window.deferredPrompt

  nextTick(() => {
    if (installPrompt.value) {
      // 使用之前保存的事件对象来触发安装提示
      installPrompt.value.prompt()

      // 等待用户选择结果
      installPrompt.value.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('用户同意安装')
        } else {
          console.log('用户拒绝安装')
        }
        // 清理保存的事件对象
        installPrompt.value = null
      })
    }
  })
}
const close = () => {
  PopupRef.value.close()
}
const handleEmitClose = () => {
  emit('close')
}

const manualClose = () => {
  PopupRef.value.manualClose()
}
const handleEmitManualClose = () => {
  emit('manualClose')
}

/**
 * 下载引导弹窗
 */
const DownloadGuidePopupRef = ref(null)
const handleDownloadGuidePopupOpen = () => {
  nextTick(() => {
    DownloadGuidePopupRef.value.open()
  })
}

/**
 * 桌面快捷方式
 */
const handleQuick = () => {
  emit('quick')
  close()
}

/**
 * 应用端安装
 */
const handleInstall = () => {}

/**
 * 应用端安装教程
 */
const handleTutorial = () => {
  handleDownloadGuidePopupOpen()
}

const emit = defineEmits(['close', 'manualClose'])

defineExpose({ open })
</script>

<style scoped lang="scss">
.download-popup {
  width: 85vw;

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 10px;

    &__images {
      display: flex;
      align-items: center;
      width: 62px;
      height: 62px;
    }

    &__label {
      width: 240px;
      font-size: 15px;
      color: var(--download-popup-value);
      line-height: 1.1;
    }
  }
}
</style>
